const HighlightStates = Object.freeze({
    ENABLED: Symbol('enabled'),
    HIGHLIGHTED: Symbol('highlighted'),
    FOCUSED: Symbol('focused'),
});

export default HighlightStates;
